<template>
    <div v-if="!loading" class="poster">
        <!--头部-->
        <Bar title="商品海报" @goBack="goBack" />
        <div class="poster-box">
            <div ref="photo" class="photo">
                <div class="poster-tips">{{info.coachName}}教练向您推荐</div>
                <img :src="info.backgroundPicUrl">
                <div class="box">
                    <img class="code" :src="info.qrCodeUrl" />
                    <div class="logo">
                        <img :src="info.logoUrl" />
                    </div>
                    <div class="text">扫码开通VIP高效学</div>
                </div>
            </div>
            <div class="poster-btn">
                <div>
                    <van-button class="custom-btn" color="#00CA84" round block @click="handleSavePhoto">保存海报</van-button>
                </div>
                <div>
                    <van-button class="custom-btn" color="#00CA84" round block @click="handleOpenShare">分享</van-button>
                </div>
            </div>
        </div>
        <Share v-if="shareStatus" :poster="info" :isGoods="posterType" :subject="subject" type="poster" @cancel="shareStatus = false" />
        <SavePhoto v-if="info.backgroundPicUrl" ref="savePoster" :info="info"></SavePhoto>
    </div>
</template>
<script>
import { Dialog, Button, Toast } from 'vant'
import { bindAppFn, isIos } from '../utils'
import Share from './components/share.vue'
import Bar from './components/bar.vue'
import SavePhoto from './components/savePhoto.vue'
export default {
    name: 'vipCoachPoster',
    components: {
        [Button.name]: Button,
        Share,
        Bar,
        SavePhoto
    },
    props: {
    },
    data () {
        return {
            info: {},
            loading: true,
            shareStatus: false,
            subject: 1,
            posterType: 0,
            isShare: false
        }
    },
    methods: {
        // 获取分享信息
        getCoachPoster () {
            const { posterType, subject } = this.$route.query
            this.subject = Number(subject || 1)
            this.posterType = !!posterType
            // 获取所在城市
            const city = JSON.parse(localStorage.getItem('vipCoachCity'))
            this.$api.getCoachPoster({
                posterType,
                cityCode: city.code,
                subject
            }).then(({ result, status, message }) => {
                this.loading = false
                if (status) {
                    this.info = result
                } else {
                    Toast.fail({ message: message })
                }
            })
        },
        goBack () {
            this.$router.back()
        },
        handleSavePhoto () {
            if (this.isShare) {
                this.$refs['savePoster'].save()
            } else {
                this.tips()
            }
        },
        handleOpenShare() {
            if (this.isShare) {
                this.shareStatus = true
            } else {
                this.tips()
            }
        },
        tips () {
            Dialog.alert({
                title: '温馨提示',
                message: '这里有更新哦，请升级至最新版本后再使用保存和分享功能!!',
                theme: 'round-button',
                className: 'vip-coach-btn',
            })
        },
        getIsShare () {
            bindAppFn({
                name: 'app',
                data: {
                    method: 'getVersion',
                    params: {}
                },
                currentFnName: 'getAppVersion',
                callback: (e) => { // 获取当前版本
                    this.isShare = !!e
                }
            })
        }
    },
    mounted () {
        bindAppFn({
            name: 'app',
            data: {
                method: 'hiddenTabbar'
            }
        })
        if (isIos) {
            this.isShare = true
        } else {
            this.getIsShare()
        }
        this.getCoachPoster()
    },
    deactivated () {
        // 离开页面将tabbar展示出来
        bindAppFn({
            name: 'app',
            data: {
                method: 'showTabbar'
            }
        })
    }
}
</script>
<style scoped lang="scss">
* {
    box-sizing: border-box;
}
.poster {
    padding: 10px 15px 65px;
    background-color: #F3F4FB;
    .poster-box{
        position: relative;
        .poster-tips{
            position: absolute;
            z-index: 2;
            top: 0;
            left: 0;
            width: 100%;
            padding: 13px;
            color: #fff;
            text-align: center;
            background-color: rgba(0,0,0,0.5);
        }
        img {
            width: 100%;
        }
        .poster-btn {
            padding: 10px 15px;
            position: fixed;
            bottom:0;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            background-color: #F3F4FB;
            &>div{
                flex: 0 0 160px;
            }
        }
    }
}
.photo{
    position: relative;
    .box{
        position: absolute;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        width: 166px;
        height: 166px;
        img{
            width: 100%;
            height: 100%;
            vertical-align: top;
        }
        .logo{
            position: absolute;
            padding: 4px;
            top: 83px;
            left: 50%;
            width: 40px;
            height: 40px;
            background-color: #fff;
            transform: translate(-50%, -50%);
            img{
                object-fit: scale-down;
            }
        }
        .text {
            margin-top: 8px;
            text-align: center;
            color: #fff;
            font-size: 17px;
            font-weight: 600;
            line-height: 1;
        }
    }
}
</style>
